export default __webpack_public_path__ + "static/media/twoPartyChitToolbar_sample.6d80d8a7.jpg";